import React, { useEffect } from "react";
import { VStack } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { KYDInput } from "src/ui";
import AudienceListItem from "../../AudienceListItem";
import {
  StepProps,
  PageLookalikeAudienceFormValues,
  buildLookalikeName,
} from "../types";

const LookalikeStep: React.FC<StepProps> = ({ lookalikeOptions }) => {
  const form = useFormContext<PageLookalikeAudienceFormValues>();
  const pageName = form.watch("pageName");
  const lookalikeRatio = form.watch("lookalike.ratio");

  useEffect(() => {
    if (!pageName || !lookalikeRatio) {
      return;
    }
    form.setValue("lookalike.name", buildLookalikeName(pageName, lookalikeRatio));
  }, [form, pageName, lookalikeRatio]);

  return (
    <VStack spacing={6} align="stretch">
      <VStack align="stretch" spacing={8}>
        {/* <Text fontSize="sm" color="gray.600">
          Create a lookalike audience based on your selected{" "}
          {form.watch("pageType") === "facebook"
            ? "Facebook page"
            : "Instagram account"}{" "}
          to reach similar people.
        </Text> */}

        <VStack align={"flex-start"} spacing={0}>
          <KYDInput
            variant="labeled"
            label="Lookalike Audience Name"
            placeholder="Enter lookalike audience name"
            value={form.watch("lookalike.name")}
            defaultValue={`Lookalike ${form.watch("pageName")}`}
            onChange={(e) => form.setValue("lookalike.name", e.target.value)}
          />
        </VStack>

        <VStack align="stretch" spacing={2}>
          {/* <Text fontSize="sm" fontWeight="500">
            Similarity Ratio
          </Text>
          <Text fontSize="xs" color="gray.600">
            Choose how similar the lookalike audience should be to your source
            audience. Lower percentages create more similar but smaller
            audiences.
          </Text> */}

          <VStack spacing={3} align="stretch">
            {lookalikeOptions.map((option) => (
              <AudienceListItem
                key={option.value}
                title={option.title}
                description={option.description}
                icon={option.icon}
                iconBgColor={option.iconBgColor}
                value={option.value}
                isSelected={lookalikeRatio === option.value}
                onSelect={(value) => {
                  form.setValue("lookalike.ratio", value);
                }}
                isRecommended={option.isRecommended}
                showRadio={true}
                showPlus={false}
              />
            ))}
          </VStack>
        </VStack>
      </VStack>
    </VStack>
  );
};

export default LookalikeStep;
